<template>
  <div class="position-relative">
    <div class="dropdown" v-if="isLoggedIn">
      <a href="#" class="dropdown-toggle nav-link" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
        <i class="icon-login d-xl-none" aria-hidden="true"></i>
        <span class="d-none d-lg-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
      </a>
      <div class="dropdown-menu small m-0 p-0 mw-100">
        <div class="list-group" aria-labelledby="accountMenuList" >
          <a href="#" class="list-group-item" v-if="userid">
            <b>{{ $translate("Servershop5::Template.customerNumber") }}:</b> {{ userid }}
          </a>
          <a :href="$ceres.urls.myAccount" class="list-group-item"><i class="icon-login"></i> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
          <a href="#" class="list-group-item" v-logout><i class="fa fa-power-off"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
        </div>
      </div>
    </div>
    <div v-if="!isLoggedIn">
      <a class="nav-link" data-testing="login-select" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
        <i class="icon-login mr-1" aria-hidden="true"></i>
        <span class="d-none d-lg-inline">{{ $translate("Ceres::Template.login") }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import ApiService from "../services/ApiService";
import ValidationService from "../services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    showRegistration: {
      type: Boolean,
      default: true
    },
    showLogin: {
      type: Boolean,
      default: true
    }
  },

  computed:
      {
        userid()
        {
          if(this.$store.state.user.userData != null)
          {
            return this.$store.state.user.userData.id;
          }
          else
          {
            return false;
          }
        },
        ...mapGetters([
          "username",
          "isLoggedIn"
        ])
      },

  data()
  {
    return {
      isLogin: App.templateType === "login",
      isRegister: App.templateType === "register"
    };
  },
  methods: {
    unmarkInputFields()
    {
      ValidationService.unmarkAllFields($("#login"));
      ValidationService.unmarkAllFields($("#registration"));
    },

    createLoginModal()
    {
      this.loadComponent("login-modal");

    },

    createRegisterModal()
    {
      this.loadComponent("register-modal");
    },

    ...mapActions([
      "loadComponent"
    ])
  }
}
</script>
